import * as React from "react";
import { forwardRef } from "react";
const SvgToolRectangle = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="#726f7e" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round"><path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
const ForwardRef = forwardRef(SvgToolRectangle);
export { ForwardRef as ReactComponent };